import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Futebol Americano",
    Baseball: "Beisebol",
    Basketball: "Basquete",
    Boxing: "Boxe",
    Chess: "Xadrez",
    Cricket: "Cricket",
    Darts: "Dardos",
    Entertainment: "Entertainment",
    "E-Sports": "E-Sports",
    Football: "Futebol",
    "Formula 1": "Fórmula 1",
    "Gaelic Football": "Futebol Gaélico",
    "Generic Sport": "Generic Sport",
    Golf: "Golfe",
    "Greyhound Racing": "Greyhound Racing",
    Handball: "Handebol",
    "Ice Hockey": "Hóquei no Gelo",
    IndyCar: "IndyCar",
    MMA: "MMA",
    Nascar: "Nascar",
    Politics: "Politics",
    "Rugby League": "Liga de Rugby",
    "Rugby Union": "Rugby Union",
    Snooker: "Sinuca internacional",
    "Table Tennis": "Tênis de mesa",
    Tennis: "Tênis",
    "Virtual Football": "Virtual Football",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} vencer",
    WinFirstRound: "{name} vencer o primeiro round",
    FirstTouchdown: "{name} marcar o primeiro touchdown",
    FirstTry: "{name} marcar o primeiro ensaio",
    TotalGoals: "{name} Total de gols",
    TotalRuns: "{name} Total de Runs",
    TotalPoints: "{name} Total de pontos",
    TopBatsman: "{name} Melhor Batsman",
    TopBowler: "{name} Melhor Bowler",
    FirstScore: "{name} marcar primeiro"
  },
  PromoTexts: {
    Pick: "Faça a suas escolhas",
    Bet: "Apostar",
    Pays: "Levantamento"
  },
  DateTimeTexts: {
    Today: "Hoje",
    Tomorrow: "Amanhã",
    Live: "Vivo"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Faça a suas escolhas",
    Return: "Levantamento",
    Stake: "Apostar",
    Draw: "X"
  },
  H2HTexts: {
    "Goals scored": "Gols marcados",
    Shots: "Chutes",
    "Shots on target": "Chute a gol",
    "Ball possession": "Posse de bola",
    "Goals conceded": "Gols concedidos",
    "Per match": "Por jogo",
    H2H: "Confronto",
    W: "V",
    D: "E",
    L: "D"
  }
};
